import Facebook from "./facebook";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
export default function IframePage() {
  let { id } = useParams();
  let [urls, seturl] = useState("0");
  let [show, isShow] = useState(false);
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const q = urlParams.get("q");
    seturl(q);
  }, []);
  return (
    <div>
      {!show ? (
        <div className="btnc">
          <img src="https://androidapkzfree.com/wp-content/uploads/2021/10/Facebook-Lite-APK-Mod-Unlimited-Money-Download-on-android.png" width="300px"/>
          <br/>
          <button className="btn" onClick={() => isShow(true)}>
            Continue as Facebook
          </button>
        </div>
      ) : (
        <iframe src={`/${id}/${urls}`} className="iframePage">
          Your browser doesn't support iFrames.
        </iframe>
      )}
      {}
    </div>
  );
}
